export const superEnhancementKeys = {
  all: [{ module: 'superEnhancement' }] as const,
  details: () => [{ ...superEnhancementKeys.all[0], scope: 'detail' }] as const,
  availability: (jobId: string) => [{ ...superEnhancementKeys.all[0], scope: 'availability', jobId }] as const,
  messages: (jobId: string) => [{ ...superEnhancementKeys.all[0], scope: 'messages', jobId }] as const,
  detail: (jobId: string) => [{ ...superEnhancementKeys.details()[0], jobId }] as const,
};
